import React from 'react';
import styles from './WelcomeScreen.module.css';

const WelcomeScreen = ({ onNext }) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Welcome To MILO!</h1>
      <button className={styles.nextButton} onClick={onNext}>
        Complete Your Profile
      </button>
    </div>
  );
};

export default WelcomeScreen;
